import { TwoFactorLoginSubmitArgs } from 'types/api/arguments/two-factor-login-submit-args'
import { TwoFactorResendResp } from 'types/api/response/two-factor-resend-resp'

import { api } from './api'

export const resendLoginTwoFactorCode = ({
  controlCode,
  code,
  fingerprint,
}: TwoFactorLoginSubmitArgs) =>
  api.post<TwoFactorResendResp>(`/user_login_2fa/${controlCode}/resend`, {
    code,
    fingerprint,
  })
